/**
 * Max Bucks (MB): pack-only credit, never withdrawable. 1 MB = $1, stored in
 * cents. Always shown as "MB 25.00" so it never reads as cash.
 */
export const MAX_BUCKS_LABEL = "Max Bucks";

export function formatMaxBucks(cents: number): string {
  const safe = Number.isFinite(cents) ? Math.max(0, Math.round(cents)) : 0;
  return `MB ${(safe / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/**
 * Seeded share of a sell-back credit: credit x seeded / price, rounded up so
 * the odd cent is seeded. The server's rule (apps/api seeded-wallet.ts).
 */
export function sellbackSeededShareCents(creditCents: number, seededCents: number, priceCents: number): number {
  if (creditCents <= 0 || seededCents <= 0 || priceCents <= 0) return 0;
  const seeded = Math.min(seededCents, priceCents);
  return Math.floor((creditCents * seeded + priceCents - 1) / priceCents);
}

/**
 * Max Bucks share of a sell-back credit (or marketplace proceeds): credit x
 * MB spent on the rip / the rip's price, rounded up so the odd cent is MB,
 * and never more than what is left after the seeded share. A $25 rip paid
 * 15 MB + $10 cash returns 60% of its sell-back as MB.
 */
export function sellbackMaxBucksShareCents(creditCents: number, promoCents: number, priceCents: number, seededShareCents = 0): number {
  if (creditCents <= 0 || promoCents <= 0 || priceCents <= 0) return 0;
  const promo = Math.min(promoCents, priceCents);
  const share = Math.floor((creditCents * promo + priceCents - 1) / priceCents);
  return Math.max(0, Math.min(share, creditCents - Math.max(0, seededShareCents)));
}
